/**
 * Created by john on 7/16/15.
 */

'use strict';

const User = require('../../../models/User');
const BaseStore = require('fluxible/addons/BaseStore');
const NavActions = require('../actions/ActionConstants').NAV;
const get = require('lodash.get');
const root = typeof document === 'undefined' ? global : document;

/**
 * Stores the state of the nav bar UI. For example, whether the search bar is expanded, menu shown,
 * user logged in, etc.
 */
class NavBarUIStateStore extends BaseStore {

    constructor(dispatcher) {
        super(dispatcher);

        this.state = {
            showNavMenu: false,
            showSearchBar: false,
            showTrade: this._canShowTrade()
        };

        // set up listener on User Model
        User.getCurrentUser().on('login:change', this.updateUserStates, this);
        User.getCurrentUser().on('change:profile', this.updateUserStates, this);
    }

    _canShowTrade() {
        const bodyEl = root.querySelector('body');
        return get(bodyEl, 'className', '').indexOf('is-trade') >= 0;
    }

    getState() {
        return this.state;
    }

    updateUserStates() {
        const loggedIn = User.loggedIn();

        if (loggedIn) {
            User.load().always(() => {
                this.state.showTrade = this._canShowTrade();
                this.emitChange();
            });
        }
    }

    /**
     * Handler for when the navigation menu state changes.
     * @param payload
     * @param payload.visible {boolean}
     */
    onToggleNavMenu(payload) {
        this.state.showNavMenu = !!payload.visible;
        this.emitChange();
    }

    /**
     * Handles showing and hiding the search bar.
     * @param payload
     * @param payload.visible {boolean}
     */
    onToggleSearchBar(payload) {
        this.state.showSearchBar = !!payload.visible;
        this.emitChange();
    }
}

NavBarUIStateStore.storeName = 'NavBarUIStateStore';

NavBarUIStateStore.handlers = {
    [NavActions.TOGGLE_MENU]: 'onToggleNavMenu',
    [NavActions.TOGGLE_SEARCH]: 'onToggleSearchBar'
};

module.exports = NavBarUIStateStore;



// WEBPACK FOOTER //
// ./assets/js/global/core/nav/stores/NavBarUIStateStore.es.js